import DataSource from "devextreme/data/data_source";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs/internal/Observable";
import { cardSummayDetail } from "../components/utils/models/cardsummaydetail";
import { LedgerTransactionRecord } from "../components/utils/models/LedgerTransactionRecord";
import { EnvironmentService } from "./environment.service";


@Injectable()
export class LedgerTransactionService{

    constructor(private http: HttpClient, private environmentService: EnvironmentService) { }

    getCardValues() : Observable<cardSummayDetail[]>
    {
        return this.http.get<cardSummayDetail[]>(`${this.environmentService.getConfig('BackendApi')}api/LedgerTransactions/GetCardValues`);
    }


    getPagedLedgerTransactions(page: number, pageSize: number,filter? : string): Observable<{ data: LedgerTransactionRecord[], totalRecords: number ,summary : number[] }> {
        let params = new HttpParams()
          .set('PageNumber', page.toString())
          .set('PageSize', pageSize.toString());

          if(filter){
            params = params
            .set('$filter',filter.toString());
          }
    
        return this.http.get<{ data: LedgerTransactionRecord[], totalRecords: number, summary : number[] }>(`${this.environmentService.getConfig('BackendApi')}odata/LedgerTransactions`, { params });
    }
}
